module.exports = __webpack_public_path__ + "static/media/tech-video-3.7b9bd3f5.png";